/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ supplier: NonNullable<unknown>, since: NonNullable<unknown> }} Inbound_Waiting_On_MissingInputs */

const en_inbound_waiting_on_missing = /** @type {(inputs: Inbound_Waiting_On_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on ${i?.supplier} · units missing · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on {supplier} · units missing · since {since}" |
*
* @param {Inbound_Waiting_On_MissingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_waiting_on_missing = /** @type {((inputs: Inbound_Waiting_On_MissingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Waiting_On_MissingInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_waiting_on_missing(inputs)
});